import { useCallback, useEffect, useState } from 'react';

export function useMobileMenu() {
  const [open, setOpen] = useState(false);

  const toggle = useCallback(() => setOpen((v) => !v), []);
  const close = useCallback(() => setOpen(false), []);

  useEffect(() => {
    // Close on route hash / history changes initiated outside the header
    const onPop = () => setOpen(false);
    window.addEventListener('popstate', onPop);
    window.addEventListener('hashchange', onPop);
    return () => {
      window.removeEventListener('popstate', onPop);
      window.removeEventListener('hashchange', onPop);
    };
  }, []);

  return { open, toggle, close };
}

